<template>
  <button
    :modifierId="modifierId"
    :class="['chip', { 'chip--selected': selected }]"
    :disabled="disabled"
    @click.prevent="(e) => $emit('update', e, modifierId)"
  >
    <div class="chip__text" :class="{ 'chip--disabled': disabled }">
      <img :src="getIconPath()" />
      {{ text }}
    </div>
    <slot></slot>
    <div v-if="!disabled" class="chip__overlay" />
  </button>
</template>

<script>
export default {
  name: "ModifierChip",
  props: {
    modifierId: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    selected: Boolean,
    disabled: Boolean
  },
  methods: {
    getIconPath() {
      const filename = this.selected ? "instruction_checked_icon.svg" : "instruction_icon.svg";
      return require(`@/assets/images/${filename}`);
    }
  }
};
</script>

<style scoped lang="scss">
.chip {
  transition: background-color 0.5s;
  cursor: pointer;
  display: flex;
  position: relative;
  color: $group-3-color-3;
  font-weight: $font_regular;
  font-size: 14px;
  height: 35px;
  box-sizing: border-box;
  border: solid 0.6px rgba(141, 154, 174, 0.4);
  background-color: $group-3-color-1;
  border-radius: 5px;
  padding: 0;
  margin: 0 5px 10px 5px;

  &__text {
    padding: 7px 16px 8px 16px;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      margin-right: 5px;
    }
  }

  &__overlay {
    transition: background-color 0.5s;
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 5px;
    opacity: 0;
  }

  @include hover-supported() {
    &:hover &__overlay {
      background-color: $group-3-color-4;
      opacity: 0.04;
    }
  }

  &:active &__overlay {
    transition: background-color 0s;
    background-color: black;
    opacity: 0.1;
  }

  &--selected {
    transition: background-color 0.5s;
    background-color: $group-3-color-4;
    color: $group-3-color-1;

    @include hover-supported() {
      &:hover {
        .chip__overlay {
          background-color: white;
          opacity: 0.16;
        }
      }
    }

    &:active {
      .chip__overlay {
        background-color: black;
        opacity: 0.1;
      }
    }
  }
  &--disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
}
</style>
